import { UpdateAllAEPNResponse } from "@nxsys/types/api/aepn";
import axios from "../axios";
import { endPoints } from "../endpoints";

export const updateAllAEPNApi = async (
): Promise<UpdateAllAEPNResponse> => {
  const response = await axios.get(`${endPoints.aepn.main}/download`);
  return response.data;
};